import { Injectable } from '@angular/core'
import { Actions, Effect, ofType } from '@ngrx/effects'
import { Toaster } from '@tokeet-frontend/tv3-platform'
import { catchError, map, switchMap, tap } from 'rxjs/operators'
import { of } from 'rxjs'
import { HopperChannelService } from './service'
import {
  ActivateHopperListing,
  ActivateHopperListingSuccess,
  ConnectHopper,
  ConnectHopperSuccess,
  CreateHopperListing,
  CreateHopperListingSuccess,
  DeactivateHopperListing,
  DeactivateHopperListingSuccess,
  DisconnectHopper,
  DisconnectHopperSuccess,
  GetHopperListings,
  GetHopperListingsSuccess,
  GetHopperRentalValidations,
  GetHopperRentalValidationsSuccess,
  GetHopperStatus,
  GetHopperStatusSuccess,
  UpdateHopperListing,
  UpdateHopperListingSuccess,
} from './actions'
import { ActionFailed } from '@tokeet-frontend/tv3-platform'

@Injectable()
export class HopperChannelEffects {
  @Effect()
  getHopperStatus$ = this.actions$.pipe(
    ofType(GetHopperStatus),
    switchMap(() =>
      this.channelsService.getStatus().pipe(
        map((status) => GetHopperStatusSuccess({ status })),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  // @Effect()
  // deleteHopperListing$ = this.actions$.pipe(
  //   ofType(DeleteHopperListing),
  //   switchMap(({ listingId }) =>
  //     this.channelsService.deleteListing(listingId).pipe(
  //       tap(() => this.toaster.success('Listing deleted successfully')),
  //       map(() => DeleteHopperListingSuccess({ listingId })),
  //       catchError((error) => of(ActionFailed({ error })))
  //     )
  //   )
  // )

  @Effect()
  connectHopper$ = this.actions$.pipe(
    ofType(ConnectHopper),
    switchMap(({ email, name }) =>
      this.channelsService.connect({ email, name }).pipe(
        tap(() => this.toaster.success($localize`Hopper connected successfully`)),
        map(() => ConnectHopperSuccess()),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  @Effect()
  activateHopperListing$ = this.actions$.pipe(
    ofType(ActivateHopperListing),
    switchMap(({ rentalId, listingId }) =>
      this.channelsService.activateListing(listingId).pipe(
        tap(() => this.toaster.success($localize`Listing activated successfully`)),
        map(() => ActivateHopperListingSuccess({ rentalId, active: true })),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  @Effect()
  deactivateHopperListing$ = this.actions$.pipe(
    ofType(DeactivateHopperListing),
    switchMap(({ rentalId, listingId }) =>
      this.channelsService.deactivateListing(listingId).pipe(
        tap(() => this.toaster.success($localize`Listing deactivated successfully`)),
        map(() => DeactivateHopperListingSuccess({ rentalId, active: false })),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  @Effect()
  getHopperListings$ = this.actions$.pipe(
    ofType(GetHopperListings),
    switchMap(() =>
      this.channelsService.getListings().pipe(
        map((listings) => GetHopperListingsSuccess({ listings })),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  @Effect()
  createHopperListing$ = this.actions$.pipe(
    ofType(CreateHopperListing),
    switchMap(({ listing }) =>
      this.channelsService.createListing(listing).pipe(
        tap(() => this.toaster.success($localize`Listing created successfully.`)),
        map((response) => CreateHopperListingSuccess({ listing })),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  @Effect()
  getHopperRentalValidations$ = this.actions$.pipe(
    ofType(GetHopperRentalValidations),
    switchMap(() =>
      this.channelsService.getRentalValidations().pipe(
        map((validations) => GetHopperRentalValidationsSuccess({ validations })),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  @Effect()
  updateHopperListing$ = this.actions$.pipe(
    ofType(UpdateHopperListing),
    switchMap(({ listing }) =>
      this.channelsService.updateListing(listing).pipe(
        tap(() => this.toaster.success($localize`Listing updated successfully.`)),
        map((response) => UpdateHopperListingSuccess({ listing })),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  @Effect()
  disconnectHopper$ = this.actions$.pipe(
    ofType(DisconnectHopper),
    switchMap(() =>
      this.channelsService.disconnect().pipe(
        tap(() => {
          this.toaster.success($localize`Hopper disconnected successfully`)
        }),
        map(() => DisconnectHopperSuccess()),
        catchError((error) => of(ActionFailed({ error })))
      )
    )
  )

  constructor(private actions$: Actions, private channelsService: HopperChannelService, private toaster: Toaster) {}
}
